import React from 'react';
const MemberContainer = React.memo(({ className, styles, children }) => {
    return (React.createElement("div", { className: className, style: styles && {
            width: `${styles.width}px`,
            height: `${styles.height}px`,
            backgroundColor: '#000',
        } }, children));
});
export default MemberContainer;
